export default function (context) {
    let date = new Date();
    context.state.dateType = 1;
    context.state.dates = [
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear()
    ];
    context.state.CurrencyId = [];
    context.state.PayStates = [];
    context.state.PaymentTypeIds = [];
    context.state.CashList = [];
    context.state.PaymentAccountList = [];
    context.state.ManagerList = [];
    context.state.DepartmentList = [];
    context.state.InvoiceSumFrom = 0;
    context.state.InvoiceSumTo = 0;
    context.state.PaymentOperationId = '';
    context.state.CategoryId = '';
    context.state.ContragentId = '';
    context.state.ContragentName = '';
    context.state.ContragentSearchTypeId = '';
    context.state.KindOfPayId = '';
    context.state.AccountNumber = '';
    context.state.AgreementCode = '';
    context.state.OnlyOverdue = false;
}